import Vue from 'vue'
import vueStickySidebar from 'vue-sticky-sidebar'

Vue.component('vue-sticky-sidebar', vueStickySidebar)
